<alg-left-header [hideTree]="hideTree()" [treeHidden]="compactHeader()"></alg-left-header>
<alg-left-tabbed-content
  class="alg-flex-1"
  [hideTree]="hideTree()"
  (searchActiveChange)="searchActive.set($event)"
></alg-left-tabbed-content>
